import { Button } from '@mantine/core';
import { CalendarX } from 'lucide-react';

import Paragraph from '@/components/text/Paragraph.tsx';

interface Props {
    onBookManually: () => void;
}

export const ChainSuggestionEmpty = ({ onBookManually }: Props) => (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 p-6 text-center">
        <div className="flex size-12 items-center justify-center rounded-full bg-amber-100">
            <CalendarX className="size-6 text-amber-500" />
        </div>
        <div className="flex flex-col gap-1">
            <Paragraph className="font-semibold">Keine freie Terminkette gefunden</Paragraph>
            <Paragraph className="text-sm text-slate-500">
                Für die gewählte Terminkette konnten keine freien Termine gefunden werden – die Kalender sind im
                durchsuchten Zeitraum vollständig belegt.
            </Paragraph>
        </div>
        <Button onClick={onBookManually}>Manuell planen</Button>
    </div>
);
